import { Container, Form } from 'react-bootstrap';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { blastingAgreementSchema } from '../../schemas/blastingAgreementSchema';
import { ControlButtons } from '../ControlButtons';

export function BlastingAgreement({
	currCondition = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	enableLoading = false,
}) {
	const { register, formState, handleSubmit } = useForm({
		resolver: yupResolver(blastingAgreementSchema),
		defaultValues: currCondition,
	});
	return (
		<Container className="component mt-4">
			<Container className="component mb-5">
				<h1>Explosive Blasting Agreement</h1>
				<p>
					It is understood and agreed that the holder of this Permit shall
					indemnify and hold harmless Utah County from and against all losses
					and claims, demands, payments, suits, actions, recoveries, and
					judgments of every nature and description brought or recovered against
					it by reason of any omission or act of the Permittee, its agents, or
					employees in the execution of the conduct authorized by this Permit.
					The Permittee shall obtain, maintain, and pay the premiums for
					liability insurance in an amount not less than $2,500,000 U.S. dollars
					naming Utah County as an additional insured on said policy and with
					provisions that protect Utah County from contingent liability under
					this Permit. Proof of such insurance policy or policies shall be
					attached to the application prior to approval being given. Permittee
					shall provide a fire watch during, and for a reasonable time
					afterwards, to extinguish any and all smoldering debris. Permittee
					must provide their own water supply and equipment for that task.
					Permittee must abide by all adopted IFC 2012 (Chapter 56) and NFPA 495
					(2013 Ed.) regulations and must notify Utah County Dispatch by the
					quickest means possible of any and all working fires that may be
					caused by blasting, at (801) 794-3970 or 911. A site safety plan
					showing number of shots, distances, amounts, etc. and an explosive
					storage plan must be on site and available for inspection by the Utah
					County Fire Marshal’s office. Any questions should be directed to the
					Utah County Fire Marshal at (801) 851-8348.
				</p>
				<Form.Group>
					<Form.Check>
						<Form.Check.Input {...register('agreed')} />
						<Form.Check.Label>
							<strong>
								I have read the above permit and agree to follow the conditions
								set forth: By signing this document, I understand and
								acknowledge to comply with all Utah County and Utah State
								requirements during use of this Explosive Blasting Permit.
							</strong>
						</Form.Check.Label>
					</Form.Check>
					<Form.Text className="text-danger">
						{formState.errors.agreed?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group>
					<Form.Label>Title</Form.Label>
					<Form.Control type="text" {...register('title')} />
					<Form.Text className="text-danger">
						{formState.errors.title?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group>
					<Form.Label>Full Name</Form.Label>
					<Form.Control type="text" {...register('name')} />
					<Form.Text className="text-danger">
						{formState.errors.name?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group>
					<Form.Label>Email</Form.Label>
					<Form.Control type="text" {...register('email')} />
					<Form.Text className="text-danger">
						{formState.errors.email?.message}
					</Form.Text>
				</Form.Group>
			</Container>
			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
				enableLoading={enableLoading}
			/>
		</Container>
	);
}
